import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search--cream",
  "use": "icon-search--cream-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-search--cream\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 20c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7Zm19 8-8.04-8.04A12.888 12.888 0 0 0 26 13c0-7.168-5.832-13-13-13S0 5.832 0 13s5.832 13 13 13c2.562 0 4.946-.754 6.96-2.04L28 32l4-4Z\" fill=\"#EFE0CA\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol